<div class="">
  <h1 class="title">
    Bienvenue {{ firstStepFormControl.get("firstName")?.value }}! Commençons par
    saisir les données relatives à votre établissement
  </h1>
  <h5 class="title-text-muted text-muted fs-16">
    Ajoutez les détails essentiels de votre établissement pour garantir
    l'authenticité.
  </h5>

  <div class="row my-3">
    <app-custom-input
      [label]="'Nom de votre établissement de santé'"
      [placeholder]="'exemple : Centre Hospitalier Jean DUPONT'"
      [parentForm]="secondStepFormControl"
      controlName="name"
      [required]="true"
    ></app-custom-input>
  </div>
  <div class="row my-3">
    <app-custom-input
      [label]="'Numéro SIRET'"
      [type]="'number'"
      [parentForm]="secondStepFormControl"
      [errorMessage]="'Numéro SIRET doit avoir 14 numéro'"
      controlName="numsiret"
        (input)="onSiretInputChange($event)"
      [placeholder]="'0'"
      [required]="true"
    ></app-custom-input>
  </div>
  <div class="row my-2">
    <app-custom-drop-down
      [parentForm]="secondStepFormControl"
      controlName="typeetablissement"
      [label]="'Type de l\'établissement'"
      [options]="etablissementType"
      [required]="true"
      [simpleDropDown]="true"
    ></app-custom-drop-down>
  </div>
  <div class="row my-2">
    <app-custom-input
      [parentForm]="secondStepFormControl"
      controlName="nombresalaries"
      [type]="'number'"
      [label]="'Nombre de salariés approximatif'"
    ></app-custom-input>
  </div>
  <div class="row my-2">
    <app-custom-input
      [parentForm]="secondStepFormControl"
      controlName="nombreannuelpatients"
      [label]="'Nombre annuel de patients pris en charge'"
      [type]="'number'"
    ></app-custom-input>
  </div>
  <div class="row my-3">
    <app-custom-input
      [label]="'Numéro FINESS'"
      [type]="'number'"
      [parentForm]="secondStepFormControl"
      [errorMessage]="'Numéro FINESS doit avoir 9 numéro'"
      (input)="onFinessInputChange($event)"
      controlName="numfiness"
      [placeholder]="'0'"
    ></app-custom-input>
  </div>
  <div class="row my-3">
    <app-custom-input
      [label]="'Description'"
      [type]="'textarea'"
      [parentForm]="secondStepFormControl"
      controlName="description"
      [placeholder]="''"
    ></app-custom-input>
  </div>
  <div class="row my-3">
    <mat-label>Choix de la gestion administrative de l’intérim</mat-label>
    <app-custom-checkbox
      [label]="'Par Collary'"
      [value]="'COLLARY'"
      [checked]="
        secondStepFormControl.get('platformManagedBy')?.value == 'COLLARY'
      "
      (change)="checkBoxChange($event, 'COLLARY')"
    ></app-custom-checkbox>

    <app-custom-checkbox
      [label]="'Par votre établissement'"
      [value]="'YOURSELVES'"
      (change)="checkBoxChange($event, 'YOURSELVES')"
      [checked]="
        secondStepFormControl.get('platformManagedBy')?.value == 'YOURSELVES'
      "
    ></app-custom-checkbox>
  </div>

  <div class="row my-2">
    <app-button
      color="primary"
      [disabled]="!secondStepFormControl.valid"
      text="Suivant"
      (handleClick)="onSubmit.emit()"
      class="mx-auto text-center"
      [innerClass]="'p-3 w-100'"
    ></app-button>
  </div>
</div>
